export default "__VITE_ASSET__yMnZU9v5__"